import React from 'react';

import { ProSubscriptionPopupView, ProSubscriptionPopupClick } from 'services/activities';
import { useMutation } from 'react-query';

import ActionButton from '@core/components/actionbutton/ActionButton';

import classes from './StepProAlert.module.scss';


const StepProAlert = ({
    data,
    period,
    setPlanType,
    paymentHandlerAfterProAlert,
    checkoutServiceCallLoadingSubscription
}) => {
    const { mutate: viewActivity } = useMutation(ProSubscriptionPopupView);
    const { mutate: clickActivity } = useMutation(ProSubscriptionPopupClick);
    React.useEffect(() => {
        viewActivity({});
    }, []);
    const clickHandler = () => {
        clickActivity();
        paymentHandlerAfterProAlert()
    }
    return (
        <div className={classes.wrapper}>
            <h4>Great news — Pro benefits, Plus price</h4>
            <p>You’re seeing a limited packaging test. Thanks for helping us improve Pharmuni.</p>
            <p>You’ll still get <strong>every Pro feature</strong> you selected, but you’ll only pay the <strong>
                Plus price — 
                {
                    period === 'Monthly' ?
                        data.monthly.discounted_price ? <span>{data.monthly.currency.symbol}{data.monthly.discounted_price}/month</span> : <span>{data.monthly.currency.symbol}{data.monthly.price}/month</span>
                        :
                        data.yearly.discounted_price ? <span>{data.yearly.currency.symbol}{data.yearly.discounted_price}/month</span> : <span>{data.yearly.currency.symbol}{data.yearly.price}/month</span>
                }
                .</strong></p>
            <p>This is a win for you:<strong>All the value, for much less.</strong></p>
            <p>We’ll switch your checkout to Plus pricing automatically.</p>
            <ActionButton
                onClick={() => clickHandler()}
                loading={checkoutServiceCallLoadingSubscription}
            >
                Continue at Plus price
            </ActionButton>
        </div >
    );
};

export default StepProAlert;

